module.exports = __webpack_public_path__ + "img/xiaomi-wh.f6dcdca5.svg";